import React from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { GenerationRun, runStatusSeverity, formatRunDuration } from "./generationRuns";

interface Props {
  runs: GenerationRun[];
}

const fmt = (iso: string | null) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString();
};

const GenerationRunsCard: React.FC<Props> = ({ runs }) => {
  const periodTemplate = (r: GenerationRun) => `${r.month ?? "—"}/${r.year ?? "—"}`;
  const triggerTemplate = (r: GenerationRun) => (
    <span className="inline-flex align-items-center gap-2">
      <Tag value={r.initiatorType} severity={r.initiatorType === "MANUAL" ? "info" : undefined} />
      <span>{r.initiator}</span>
    </span>
  );
  const statusTemplate = (r: GenerationRun) => <Tag value={r.status} severity={runStatusSeverity(r.status)} />;
  const startedTemplate = (r: GenerationRun) => fmt(r.startedAt);
  const endedTemplate = (r: GenerationRun) => fmt(r.endedAt);
  const durationTemplate = (r: GenerationRun) => formatRunDuration(r);

  return (
    <Card title="Generation Runs" className="mb-4">
      <DataTable value={runs} sortMode="single" emptyMessage="No generation runs" responsiveLayout="scroll">
        <Column header="Period" body={periodTemplate} />
        <Column header="Trigger" body={triggerTemplate} />
        <Column header="Status" body={statusTemplate} sortable sortField="status" />
        <Column header="Started" body={startedTemplate} sortable sortField="startedAt" />
        <Column header="Ended" body={endedTemplate} sortable sortField="endedAt" />
        <Column header="Duration" body={durationTemplate} />
        <Column field="totalCount" header="Count" sortable />
      </DataTable>
    </Card>
  );
};

export default GenerationRunsCard;
